import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'enx-shared-ui-expansion-panel',
  standalone: true,
  imports: [CommonModule, MatExpansionModule, MatIconModule],
  templateUrl: './shared-ui-expansion-panel.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SharedUiExpansionPanelComponent {
  title = input('');
  content = input('');
  panelOpenState = false;
}
